module.exports = "/_next/static/images/change-pin-instruction-b83281e99cad2e1910773ba3e442594c.svg";